const formatCurrency = (locale, currency, minimumFractionDigits, price) => {
  if (price != null) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      minimumFractionDigits: price % 1 === 0 ? 0 : minimumFractionDigits,
      currency
    }).format(price);
  }
  throw new Error("Price shouldn't be null/undefined");
};
const formatQuantity = (locale, quantity) => {
  if (quantity <= 0) {
    throw new Error("Quantity must be greater than zero");
  }
  return new Intl.NumberFormat(locale, {}).format(quantity);
};
const formatDifferentialPrice = (locale, currency, minimumFractionDigits, priceDifference) => {
  if (priceDifference != null) {
    const formatter = new Intl.NumberFormat(locale, {
      currency,
      minimumFractionDigits,
      style: "currency"
    });
    const sign = priceDifference < 0 ? "" : "+";
    return `${sign}${formatter.format(priceDifference)}`;
  }
  throw new Error("Price Difference shouldn't be null/undefined");
};
const isValidLocale = (locale) => {
  if (!locale || !Intl.NumberFormat.supportedLocalesOf([locale]).length) {
    throw new Error(`Invalid locale: ${locale}`);
  }
  return true;
};
const formatRangePrice = (t, locale, currency, lowestPrice, highestPrice, minimumFractionDigits = 2) => {
  if (lowestPrice == null || highestPrice == null) {
    throw new Error("Prices must not be null or undefined.");
  }
  const [minPrice, maxPrice] = lowestPrice <= highestPrice ? [lowestPrice, highestPrice] : [highestPrice, lowestPrice];
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits
  });
  const formattedMin = formatter.format(minPrice);
  const formattedMax = formatter.format(maxPrice);
  return t("rangePrice", { xx: formattedMin, yy: formattedMax });
};

export { formatCurrency, formatDifferentialPrice, formatQuantity, formatRangePrice, isValidLocale };
//# sourceMappingURL=ep-pricing-esm-utils-formatter.util.js.map
